import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';

const ActionMenuItem = React.forwardRef(({ label, onClick }, ref) => {
  return (
    <MenuItem ref={ref} onClick={onClick}>
      {label}
    </MenuItem>
  );
});

export default ActionMenuItem;
